import React,{useRef, useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { Button} from "react-bootstrap";
import Avatar from "../components/Avatar";
import Dropdown from 'react-bootstrap/Dropdown';
import DialogSettings		from "../layouts/DialogSettings";
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
	<Link to="" ref={ref} onClick={(e) => { e.preventDefault(); onClick(e); }} className="dropdown-link">
		{children}
	</Link>
));
	
class UserMenu extends React.Component {


	constructor(props) {
		
		super(props);
		this.state = {
			settings: {open:false}
		};
		
		this.initial = Array.from(this.props.user.userDetails)[0];
	}


	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
	}


	render() {
		
		
		return (
			<>
				<Dropdown className="dropdown-profile ms-3 me-3" align="end">
					<Dropdown.Toggle as={CustomToggle}>
						<Avatar initial={this.initial} />
					</Dropdown.Toggle>
					<Dropdown.Menu className="mt-10-f">
						<div className="dropdown-menu-body">
							<div className="avatar avatar-xl online mb-3"><Avatar initial={this.initial} size="xl" /></div>
							<h5 className="mb-1 text-dark fw-semibold">{this.props.user.settings && this.props.user.settings.firstName}&nbsp;{this.props.user.settings && this.props.user.settings.lastName}</h5>
							<p className="fs-sm text-secondary">{this.props.user.userDetails}</p>
							<hr />
							<nav className="nav">
								<Link onClick={()=>{this.updateStatus({settings:{open:true}})}}><i className="ri-edit-2-line"></i> Edit Settings</Link>
							</nav>
							<nav className="nav">
								<Link to="/.auth/logout"><i className="ri-logout-box-r-line"></i> Log Out</Link>
							</nav>
						</div>
					</Dropdown.Menu>
				</Dropdown>
				<DialogSettings setup={this.state.settings} user={this.props.user} onUpdateUser={this.props.onUpdateUser} onClose={()=>{this.updateStatus({settings:{open:false}})}} />
			</>
		)
	}
}

export default UserMenu;